import React, {Component} from 'react';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import classNames from "classnames";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// core components
import Header from "components/Header/Header.jsx";
import Footer from "components/Footer/Footer.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import HeaderLinks from "components/Header/HeaderLinks.jsx";
import Parallax from "components/Parallax/Parallax.jsx";

import {searchPolls} from '../actions';
import LoadingSpinner from 'utils/LoadingSpinner/';
import SearchGrid from 'components/SearchGrid/SearchGrid.jsx';

import banner from "assets/img/rocket-bg.jpg";

import profilePageStyle from "assets/jss/material-kit-react/views/profilePage.jsx";

class TrendingPage extends Component {
  componentDidMount() {
    this.props.searchPolls('%');
  }

  renderAllPolls() {
    const {classes, poll} = this.props;

    if (poll.searching) {
      return <LoadingSpinner />;
    } else if (poll.qresults.query) {
      console.log('results', poll.qresults)
      // const showResStr = `Showing search results for: "${poll.qresults.query}"`;
      return (
        <div className={classes.resultsContainer}>
          {/* <p className={classes.searchResTxt}>{showResStr}</p> */}
          <GridContainer justify="center">
            <GridItem xs={12} sm={12} className={classes.navWrapper}>
              <SearchGrid trending searchData={poll.qresults.polls.reverse()}/>
            </GridItem>
          </GridContainer>
        </div>
      );
    } else {
      return (
        <div className={classes.resultsContainer}>
          {/* <p className={classes.divider}>Already signed up? <a href="/user/login">Log in</a></p> */}
          <p className={classes.searchResTxt}>Everybody is searching for something</p>
        </div>
      );
    }
  }

  render() {
    const {classes, history, auth, ...rest} = this.props;

    return (
      <div>
        <Header
          color="transparent"
          rightLinks={<HeaderLinks />}
          fixed
          changeColorOnScroll={{height: 200, color: "white"}}
          {...rest}
        />
        <Parallax small filter image={banner}>
          <div className={classes.titleContainer}>
            <h1 className={classes.tcppTitle}>Trending Polls</h1>
          </div>
        </Parallax>
        <div className={classNames(classes.main, classes.mainRaised)}>
          <div>
            <div className={classes.termsContainer}>
              <GridContainer justify="center">
                <GridItem xs={12} sm={12} md={10}>
                  <div className={classes.profile}>
                    <div className={classes.name} style={{marginTop: 75}}>
                      {this.renderAllPolls()}
                    </div>
                  </div>
                </GridItem>
              </GridContainer>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    poll: state.poll,
  };
}

const pageWithStyles = withStyles(profilePageStyle)(TrendingPage);

// export default pageWithStyles;
export default withRouter(connect(mapStateToProps, {searchPolls})(pageWithStyles));



// WEBPACK FOOTER //
// ./src/views/Trending.js